import React, { useState,useEffect } from 'react';
import { Card,Table,Placeholder } from 'react-bootstrap';
const TechCollaborations = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading1, setLoading1] = useState(true);
    const[isLoading2, setLoading2] = useState(true);
    const[Miscellaneous1,setMiscellaneous1]=useState([]);
    const[Miscellaneous2,setMiscellaneous2]=useState([]);
    useEffect(()=>
    {
        const GetMiscellaneous1 = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/40");
                const result = await response.json();
                setMiscellaneous1(result);
                if( global.config.IsPrint === true ) { console.info('GetMiscellaneous1 : Result',result); }
            }
            catch (error) 
            {
                console.error('GetMiscellaneous1 : Error', error.message);
            }
            finally
            {
                setLoading1(false);
            }
        };
        const GetMiscellaneous2 = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/41");
                const result = await response.json();
                setMiscellaneous2(result);
                if( global.config.IsPrint === true ) { console.info('GetMiscellaneous2 : Result',result); }
            }
            catch (error) 
            {
                console.error('GetMiscellaneous2 : Error', error.message);
            }
            finally
            {
                setLoading2(false);
            }
        };
        GetMiscellaneous1();
        GetMiscellaneous2();  
    },[])
    return (
        <Card className='bg-secondary-subtle mb-4'>
            <Card.Header className='text-center fs-3' data-aos="flip-up" data-aos-duration="1500">
                {appLanguage === 'hi' ? 'प्रौद्योगिकी सहयोग' : 'TECHNOLOGY COLLABORATIONS'}
            </Card.Header>
            <Card.Body>
                <React.Fragment>
                <Table responsive bordered className='rounded-top text-center overflow-hidden'>
                    <thead>
                        <tr data-aos="fade-in" data-aos-duration="1000">
                            <th>{appLanguage === 'hi' ? 'एमओयू की सूची' : "List of MoU's"}</th>
                        </tr>
                    </thead>
                    {isLoading1 ? (
                    <tbody>
                        {[...Array(10)].map((_,index)=>(
                        <tr key={index} data-aos="fade-in" data-aos-duration="1000">
                            <td className='text-start'><Placeholder xs={12} /></td>
                        </tr>
                        ))}
                    </tbody>
                    ) : (
                    <tbody>
                        {Miscellaneous1.map((sm,index)=>(
                        <tr key={index} data-aos="fade-in" data-aos-duration="1000">
                            <td className='text-start' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? sm.sm_name_hi || sm.sm_name : sm.sm_name}} />
                        </tr>
                        ))}
                    </tbody>
                    )}
                </Table>
                <Table responsive bordered className='rounded-top text-center overflow-hidden'>
                    <thead>
                        <tr data-aos="fade-in" data-aos-duration="1000">
                            <th>{appLanguage === 'hi' ? 'दिल्ली सरकार के विभागों के साथ सहयोग (एमओयू)' : 'Collaborations With Delhi Government Departments (MoUs)'}</th>
                        </tr>
                    </thead>
                    {isLoading2 ? (
                    <tbody>
                        {[...Array(10)].map((_,index)=>(
                        <tr key={index} data-aos="fade-in" data-aos-duration="1000">
                            <td className='text-start'><Placeholder xs={12} /></td>
                        </tr>
                        ))}
                    </tbody>
                    ) : (
                    <tbody>
                        {Miscellaneous2.map((sm,index)=>(
                        <tr key={index} data-aos="fade-in" data-aos-duration="1000">
                            <td className='text-start' dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? sm.sm_name_hi || sm.sm_name : sm.sm_name}} />
                        </tr>
                        ))}
                    </tbody>
                    )}
                </Table>
                </React.Fragment>                                                      
            </Card.Body>
        </Card>
    );
}
export default TechCollaborations;